<template>
  <section class="system-section section" id="system">
    <div class="shell">
      <div class="section-top">
        <div>
          <span class="eyebrow">СОБСТВЕННАЯ ТЕХНОЛОГИЯ</span>
          <h2>Камеры видят<br /><span class="gradient-text">Robotics Vision объединяет</span></h2>
        </div>
        <p class="section-intro">
          Ваша система видеонаблюдения —<br />так же близко, как вкладка браузера. <br />На
          компьютере, планшете и телефоне.
        </p>
      </div>
      <DemoApplication />
      <div class="system-benefits">
        <article>
          <span class="feature-icon">◉</span>
          <h3>Смотрите откуда удобно</h3>
          <p>Откройте камеры в браузере через настроенное защищённое подключение.</p>
        </article>
        <article>
          <span class="feature-icon">◷</span>
          <h3>Находите нужный момент</h3>
          <p>Перемещайтесь по времени и сохраняйте важные фрагменты записей.</p>
        </article>
        <article>
          <span class="feature-icon">▣</span>
          <h3>Храните записи у себя</h3>
          <p>Локальный архив продолжает работать при потере внешнего интернета.</p>
        </article>
      </div>
    </div>
  </section>
</template>
